import type { ReactNode } from 'react'

import { Container } from './Container'
import { Content } from './Content'
import { Header } from './Header'
import { Title } from './Title'
import { TitleRow } from './TitleRow'

type Props = {
	title: ReactNode
	icon?: ReactNode
	aside?: ReactNode
	children: ReactNode
}

export const ContextCard = ({ title, icon, aside, children }: Props) => (
	<Container>
		<Header>
			<TitleRow>
				{icon}
				<Title>{title}</Title>
			</TitleRow>
			{aside}
		</Header>
		<Content>{children}</Content>
	</Container>
)
